module.exports = __webpack_public_path__ + "img/skills.0ec28acf.svg";